import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import '../styles/otpvari.css';
import leftImage from '../assets/landing1.png';
import keyIcon from '../assets/key.png'; // import your key icon image

const OtpVerification = () => {
  const [timeLeft, setTimeLeft] = useState(25);
  const [otp, setOtp] = useState(['', '', '', '']);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto-focus next input
      if (value !== '' && index < 3) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleResendOtp = () => {
    if (canResend) {
      setTimeLeft(25);
      setCanResend(false);
      setOtp(['', '', '', '']);
      // Focus on first input
      const firstInput = document.getElementById('otp-input-0');
      if (firstInput) firstInput.focus();
      // Here you would typically call your OTP resend API
    }
  };

  const formatTime = (seconds) => {
    return `00:${seconds.toString().padStart(2, '0')}`;
  };
    const navigate = useNavigate();

  const handleVerifyOTP = () => {
    navigate("/passwordreset"); // ✅ redirects to password reset page
  };

  return (
   
    <div className="otp-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right OTP Verification Section */}
      <div className="right-side">
        <div className="otp-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          
          <div className="otp-header">
            {/* Icon placed above the OTP Verification title */}
            <div className="icon-container">
              <img src={keyIcon} alt="OTP Icon" className="otp-icon" />
            </div>
            <h2 className="otp-title">OTP Verification</h2>
            <p className="otp-message">
              OTP has been sent via SMS to <span className="mobile-number">+017894505286</span>
            </p>
            <p className="otp-instruction">Enter the OTP Below</p>
          </div>

          <form>
            <div className="otp-inputs">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="otp-input"
                  autoFocus={index === 0}
                />
              ))}
            </div>

            <div className="resend-section">
  {canResend ? (
    <button className="resend-btn" onClick={handleResendOtp}>
      Resend OTP
    </button>
  ) : (
    <p className="resend-timer">
      Resend OTP in <span className="time">{formatTime(timeLeft)}</span>
    </p>
  )}
</div>


            <button 
      type="button" 
      className="verify-btn" 
      onClick={handleVerifyOTP}
    >
      Verify OTP
    </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;